import toast from 'react-hot-toast';
import { showPublishSuccess } from '@/lib/publishSuccess';
import { extractErrorMessage } from '@/lib/utils/errorMessages';

// Custom toast functions with your design system
export const showToast = {
  success: (message: string) => {
    toast.success(message, {
      duration: 3000,
      position: 'top-center',
      style: {
        background: '#047857',
        color: '#fff',
        padding: '16px',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
      },
      iconTheme: {
        primary: '#fff',
        secondary: '#047857',
      },
    });
  },

  error: (message: string | unknown) => {
    const friendlyMessage = typeof message === 'string' 
      ? message 
      : extractErrorMessage(message);
    
    toast.error(friendlyMessage, {
      duration: 4000,
      position: 'top-center',
      style: {
        background: '#DC2626',
        color: '#fff',
        padding: '16px',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
      },
      iconTheme: {
        primary: '#fff',
        secondary: '#DC2626',
      },
    });
  },

  info: (message: string) => {
    toast(message, {
      duration: 3000,
      position: 'top-center',
      icon: 'ℹ️',
      style: {
        background: '#681628',
        color: '#fff',
        padding: '16px',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
      },
    });
  },

  loading: (message: string) => {
    return toast.loading(message, {
      position: 'top-center',
      style: {
        background: '#fff',
        color: '#374151',
        padding: '16px',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
        border: '1px solid #E5E7EB',
      },
    });
  },

  promise: <T,>(
    promise: Promise<T>,
    messages: {
      loading: string;
      success: string;
      error: string;
    }
  ) => {
    return toast.promise(
      promise,
      {
        loading: messages.loading,
        success: messages.success,
        error: messages.error,
      },
      {
        position: 'top-center',
        style: {
          padding: '16px',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '500',
        },
        success: {
          style: {
            background: '#047857',
            color: '#fff',
          },
          iconTheme: {
            primary: '#fff',
            secondary: '#047857',
          },
        },
        error: {
          style: {
            background: '#DC2626',
            color: '#fff',
          },
          iconTheme: {
            primary: '#fff',
            secondary: '#DC2626',
          },
        },
      }
    );
  },

  publishSuccess: (options?: { title?: string; message?: string; onGoHome?: () => void }) => {
    showPublishSuccess(options);
  },
};

export { toast };
